import { CircularProgress, TableCell, TableRow } from '@mui/material';

type LoadingRowProps = {
  colSpan: number;
};

export function LoadingRow({ colSpan }: LoadingRowProps) {
  return (
    <TableRow>
      <TableCell component="th" scope="row" colSpan={colSpan} align="center">
        <CircularProgress size={15} /> Carregando
      </TableCell>
    </TableRow>
  );
}
